import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RevenueSharedPaymentCalculation } from './Pages';

export const RevenueSharedPaymentCalculationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={RevenueSharedPaymentCalculation} />
        
    </Fragment>
)